import { css } from "react-emotion";
import { fadeIn, flex, flexColumn, flatWrapper } from "appStyles";

export const container = css`
  position: relative;
  z-index: 2;
  width: 100%;
  height: 90%;
  overflow-y: scroll;

  * {
    margin-bottom: 5px;
  }
  ::-webkit-scrollbar {
    height: 4px;
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.075);
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgb(192, 192, 192);
    border-radius: 10px;
    width: 8px;
    height: 4px;
    &:hover {
      background-color: rgb(124, 124, 124);
    }
  }
`;

export const ImageContainer = css`
  width: 100%;
  max-height: 218px;
  position: relative;
`;

export const image = css`
  width: 100%;
  object-fit: cover;
  position: relative;
`;
export const progressBar = css`
  animation: ${fadeIn} 3s;
  position: relative;
  width: 90%;
  height: 0.5rem;
  border-radius: 0.4rem;
  background: rgba(40, 40, 40, 0.2);
  overflow: hidden;
  margin: 2rem 0;
`;

export const progress = css`
  height: 100%;
  background: rgba(40, 200, 180, 1);
  transition: 1s;
`;

export const appName = css`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 1rem;
`;

export const address = css`
  display: flex;
  align-item: flex-start;
  text-align: center;

  img {
    width: 0.8rem;
    height: 1.3rem;
    margin-right: 1rem;
    margin-top: 0.05rem;
  }
`;

export const link = css`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 0.3rem;

  img {
    width: 1rem;
    height: 1rem;
    margin-right: 1rem;
    border: none;
    outline: none;
    animation: ${fadeIn} 2s;
  }
`;

export const title = css`
  text-align: center;
  color: black;
  position: relative;
  /* z-index: 2; */
`;
